import Vue from 'vue'
import { Button, Container, Header, Main, Aside, Tabs, TabPane, Table, TableColumn, Input, Transfer, Popover, Dialog, Select, Pagination } from 'element-ui'

Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Transfer)
Vue.use(Popover)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Pagination)
